import React from 'react';
import G from "../libs/Glob.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import {Button, Form, Input, InputGroup, InputGroupText} from "reactstrap";
import appLib from "../libs/appLib.mjs";

const prefix="PasswordChange"

const PasswordChange = class extends React.Component {
	constructor(props) {
		super(props);
		this.state={
			token: "",
			tokenError: G.label('Short'),
			pwd1: "",
			pwd1Error: G.label('Short'),
			pwd2: "",
			pwd2Error: G.label('Short'),
			valid: false,
			user: G.getStatus('passwordChangeForUser')
		};
		this.uid = G.generateUid(prefix);
		this.setValue = this.setValue.bind(this);
	}

	componentDidMount() {
		if ( ! this.state.user ) G.rmCurrentPageParam('action');
	}

	setValue(field,v="") {
		if ( field === "token" ) v = v.toLowerCase().replace(/[^a-z0-9_.-]/g,'');
		const ns = this.state;
		ns[field] = v;
		ns.tokenError = ns.token.length > 3 ? undefined : G.label('Short');
		ns.pwd1Error = ns.pwd1.trim().length > 6 ? undefined : G.label('Short');
		if ( ns.pwd1.trim() !== ns.pwd2.trim() ) {
			ns.pwd2Error = G.label('Mismatch');
		} else if ( ns.pwd1.trim().length < 5 ) {
			ns.pwd2Error = G.label('Short');
		} else {
			ns.pwd2Error = undefined;
		}
		ns.valid = !( ns.tokenError || ns.pwd1Error || ns.pwd2Error );
		this.setState( ns );
	}

	render() {
		return(
			<div className={"Login " + prefix} id={this.uid}>
				<h4>
					<small><TextLabel value={"Password change"}/>: {this.state.user}</small>
				</h4>
				<div>
					<span>
						<TextLabel value={"TokenWasSent"}/>
					</span>
				</div>
				<Form
					onSubmit={e => {
						e.preventDefault();
						if (!this.state.valid || this.state.checking) return;
						this.setState({ checking: true }, ()=>{
							appLib.chPwdByToken(
								this.state.user,
								this.state.token,
								this.state.pwd1
							).then( ()=>{
								G.rmCurrentPageParam('action');
							}).catch( e => {
								console.error(e);
								this.setState({ checking: false }, ()=>{
									this.setValue('token','');
								});
							});
						});
					}}
				>
					<div>
						<InputGroup>
							<InputGroupText>
								<TextLabel value={"Token"}/>:
							</InputGroupText>
							<Input
								autoFocus={true}
								type={"text"}
								disabled={this.state.checking}
								value={this.state.token}
								valid={!this.state.tokenError}
								invalid={!!this.state.tokenError}
								autoComplete="one-time-code"
								name="token"
								pattern="[a-z0-9]{6}"
								onChange={e => this.setValue('token', e.currentTarget.value)}
							/>
							{this.state.tokenError && (
								<InputGroupText>
									🚫 {this.state.tokenError}
								</InputGroupText>
							)}
						</InputGroup>
						<div className={"mt-2"}>
							<TextLabel value={"Set password"}/>
						</div>
						<InputGroup>
							<InputGroupText>
								<TextLabel value={"Password"}/>:
							</InputGroupText>
							<Input
								type={"password"}
								disabled={this.state.checking}
								value={this.state.pwd1}
								onChange={e => this.setValue('pwd1', e.currentTarget.value)}
								onBlur={() => {
									this.setValue('pwd1', this.state.pwd1.trim())
								}}
								valid={!this.state.pwd1Error}
								invalid={!!this.state.pwd1Error}
							/>
							{this.state.pwd1Error && (
								<InputGroupText>
									🚫 {this.state.pwd1Error}
								</InputGroupText>
							)}
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<TextLabel value={"Verify"}/>:
							</InputGroupText>
							<Input
								type={"password"}
								disabled={this.state.checking}
								value={this.state.pwd2}
								onChange={e => this.setValue('pwd2', e.currentTarget.value)}
								onBlur={() => {
									this.setValue('pwd2', this.state.pwd2.trim())
								}}
								valid={!this.state.pwd2Error}
								invalid={!!this.state.pwd2Error}
							/>
							{this.state.pwd2Error && (
								<InputGroupText>
									🚫 {this.state.pwd2Error}
								</InputGroupText>
							)}
						</InputGroup>
					</div>
					<div>
						<div>
							<Button
								onClick={() => {
									G.setCurrentPageParam('action', 'forgot')
								}}
							>
								<TextLabel value={"Cancel"}/>
							</Button>
							<Button
								type="submit"
								color={"primary"}
								disabled={!this.state.valid || this.state.checking}
							>
								<TextLabel value={"Set password"}/>
							</Button>
						</div>
					</div>
				</Form>
			</div>
		)
	}
}

export default PasswordChange;